export default "__VITE_ASSET__sNeDHt99__"